import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from "@angular/router";
import { LocalStorageService } from "src/core/services/local-storage.service";
import { UserService } from "src/core/services/user.service";
import { CognitoUserInterface } from '@aws-amplify/ui-components';
import { User, UserListQuery } from "src/interfaces/user";

@Injectable({
    providedIn: 'root'
})
export class UserResolver implements Resolve<any> {

    constructor(private _userService: UserService) { }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<User | null> {
        return this
            ._userService
            .getUser(
                route.params['name']
            )
    }
}

@Injectable({
    providedIn: 'root'
})
export class UsersResolver implements Resolve<any> {
    limit: number = 10;
    page: number = 1;
    constructor(
        private _userService: UserService,
        private localStorageService: LocalStorageService
    ) {
        const limit = this.localStorageService.get('USERS', 'LIMIT');
        if (limit) {
            this.limit = parseInt(limit);
        }
    }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<User[]> {
        const token: string | null = route.queryParamMap.get('token');
        const query: UserListQuery = {};
        const search = route.queryParamMap.get('search');
        if (search != null && search.trim() !== '') {
            query.search = search.trim();
        }
        const practice =
            route.queryParamMap.get('search_practice') ||
            route.queryParamMap.get('practice');
        if (practice != null && practice.trim() !== '') {
            query.searchPractice = practice.trim();
        }
        const enabledParam = route.queryParamMap.get('enabled');
        if (enabledParam) {
            const v = enabledParam.toLowerCase();
            if (v === 'all' || v === 'both' || v === '*') {
                query.enabled = 'all';
            } else if (v === '0' || v === 'false' || v === 'disabled') {
                query.enabled = 'disabled';
            }
        }
        return this._userService.getUsers(this.limit, token, query);
    }
}